module.exports = __webpack_public_path__ + "img/14_39.b43e0e99.png";